import { Button, EmptyState } from '@nexo/ui';
import { useQuery } from '@tanstack/react-query';
import { MailX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router';
import { Logo } from '../../components/Logo';
import { api } from '../../lib/api';
import { FullScreenSpinner } from '../auth/RequireAuth';
import { useAuth, useMe } from '../auth/AuthProvider';
import { InviteCard } from './HomePage';
import { errorMessage } from '../../lib/forms';

/** Landing page for invitation links: /invite/:token */
export function InvitePage() {
  const { token = '' } = useParams();
  const me = useMe();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const invite = useQuery({
    queryKey: ['invite', token],
    queryFn: () => api.invites.preview(token),
    retry: false,
  });

  if (invite.isPending) return <FullScreenSpinner />;

  return (
    <div className="flex min-h-full flex-col items-center justify-center bg-canvas px-4 py-10">
      <Logo className="mb-8" />
      <div className="w-full max-w-lg">
        {invite.isError ? (
          <EmptyState
            icon={<MailX className="size-8" />}
            title={t('Invitación no válida')}
            description={errorMessage(invite.error)}
            action={
              <Link to="/app" className="text-sm font-medium text-accent hover:underline">
                {t('Ir a la app')}
              </Link>
            }
          />
        ) : (
          <>
            <InviteCard
              invite={invite.data}
              onDone={(teamId) => void navigate(teamId ? `/app/t/${teamId}` : '/app/home')}
            />
            {!invite.data.forCurrentUser && (
              <p className="mt-4 text-center text-sm text-muted">
                {t('Has iniciado sesión como {{email}}.', { email: me.email })}{' '}
                <Button variant="ghost" size="sm" onClick={() => void logout()}>
                  {t('Cambiar de cuenta')}
                </Button>
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
